<template>
	<div :class="{ 'bubble-container': true, 'bubble-you': isAuthor, 'bubble-other': !isAuthor }">
		<div class="bubble-header">
			<h5 class="bubble-author">{{ author }} le {{ createdAt }} :</h5>
		</div>
		<div class="bubble-content">
			{{ message }}
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			author: String,
			createdAt: String,
			message: String,
			isAuthor: Boolean,
		},
	};
</script>

<style>
	.bubble-container {
		border-radius: 5px;
		box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
		padding: 8px 12px;
		margin-bottom: 20px;
		max-width: 60%;
	}

	.bubble-you {
		background-color: #1877f2;
		color: white;
		align-self: flex-end;
		justify-self: flex-end;
	}

	.bubble-other {
		background-color: #f0f2f5;
		color: rgb(5, 5, 5);
		align-self: flex-start;
	}

	.bubble-author {
		font-size: 1rem;
		text-decoration: underline;
		margin-bottom: 10px;
	}

	.bubble-content {
		white-space: pre-line;
	}
</style>
